var _mask, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "lvn3ie6gja",
    width: 38,
    height: 32,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 1h37.707v31.636H0V1z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M13.32 32.636c-.414 0-.826-.154-1.145-.465L.495 20.785c-.446-.435-.608-1.087-.414-1.68.192-.593.705-1.026 1.323-1.116l15.288-2.222L23.53 1.914C23.805 1.354 24.375 1 25 1c.625 0 1.195.354 1.471.914l6.837 13.853 2.997.436c.895.13 1.516.963 1.386 1.858-.13.896-.962 1.516-1.858 1.387l-3.85-.56c-.534-.077-.995-.413-1.234-.896L25 6.344l-5.748 11.648c-.24.483-.7.819-1.236.896L5.162 20.756l9.302 9.066c.648.633.661 1.67.03 2.319-.322.33-.747.495-1.174.495",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M10.563 48.712c-.34 0-.678-.106-.964-.313-.504-.367-.758-.989-.653-1.603l1.162-6.776c.155-.893 1.005-1.49 1.894-1.34.893.153 1.492 1 1.34 1.893l-.602 3.503 11.498-6.044c.477-.252 1.048-.252 1.525 0l11.497 6.044-2.195-12.802c-.091-.532.085-1.075.47-1.452l9.303-9.067c-.865-.156-1.459-.971-1.332-1.85.13-.895.97-1.515 1.858-1.386l3.232.47c.618.09 1.13.522 1.324 1.115.193.595.032 1.245-.415 1.681L38.442 31.57l2.612 15.227c.105.614-.148 1.236-.653 1.603-.505.366-1.173.415-1.726.125L25 41.335l-13.674 7.19c-.24.125-.503.187-.763.187",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.95c0867c4c17f0ec9af0b013d05fd62b.svg";
export { ForwardRef as ReactComponent };